import Api from "../../axios"

export const getAttendanceRequest = async (employeeId) => {
  return await Api.get(`/attendance_request_list?employee_id=${employeeId}`);
};